import { ReactElement, useEffect, useState } from "react";
import { PrivacyService } from "../../../PolicyPages/PolicyService";
import { TermsTypeKeys } from "../../../TermsUpdate/utils";
import EditorResult from "../../../../components/HtmlEditor/EditorResult";
import Loading from "../../../../components/Loading/Loading";


type TermsProps = {};

function Terms(props: TermsProps): ReactElement {

    const [isLoaded, setLoaded] = useState(false);
    const [content, setContent] = useState<string>('')


    useEffect(() => {
        PrivacyService.getContentByType(
            TermsTypeKeys.TERMS_OF_RETURN_SHIPMENT
        ).then(({ data }) => {
            setContent(data.text);
            setLoaded(true);
        });
    }, []);

    return (
        <div className="w-full px-2">
            {
                isLoaded ? (
                    <>
                        <div className="overflow-y-auto">
                            <EditorResult content={content} />
                        </div>
                    </>

                ) : (
                    <div className="h-full flex justify-content-center align-items-center">
                        <Loading horizontalSpacing={120} />
                    </div>
                )
            }
        </div>
    )
}

export default Terms